import { render, staticRenderFns } from "./title-new.vue?vue&type=template&id=bd8330e2&scoped=true"
import script from "./title-new.vue?vue&type=script&lang=js"
export * from "./title-new.vue?vue&type=script&lang=js"
import style0 from "./title-new.vue?vue&type=style&index=0&id=bd8330e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8330e2",
  null
  
)

export default component.exports